import { Component, OnInit } from '@angular/core';
import { ApiUrl } from 'src/app/services/apiUrl';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-admin-list',
  templateUrl: './admin-list.component.html',
  styleUrls: ['./admin-list.component.scss'],
})
export class AdminListComponent implements OnInit {
  page: any = 1;
  total: any = 0;
  pageSize = 10;
  storeList: any;
  word: any = '';
  count: number = 5;

  id: any;
  source: any;
  profileImg: any;
  profileFile: any;
  imagePath: string = environment.imageUrl;
  selectedPage: any;
  timeout: any = null;
  // profileimage:any

  constructor(
    private service: ApiService,
    private route: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getAdminList();
  }
  getAdminList() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.adminList + `?page=${this.page}&word=${this.word}`).subscribe(
      (res: any) => {
        this.source = res.response.data.admins;
        this.total = res.response.data.adminCount;
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  addAdmin() {
    this.route.navigate(['/adminregister']);
  }

  editAdmin(id: any) {
    this.route.navigate(['/adminedit/' + id]);
  }

  confirmDelete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.deleteAdmin(this.id);
      }
    });
  }
  pageChanged(event: any) {
    this.page = event;
    this.selectedPage = event;
    this.getAdminList();
  }

  deleteAdmin(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.service.deletRequest(`${ApiUrl.adminDelete}/${id}`).subscribe(
          (res: any) => {
            // console.log(res, "delete")
            this.toastr.success(res.response.message);
            this.getAdminList();
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
          }
        );
      }
    });
  }
  onFilterKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getAdminList();
    }, 1000);
  }
}
